import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { useTheme, Button, Badge, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { green, red, blue, purple } from '@mui/material/colors';

import { ScrollableContainer, BasicFlex } from '../../utils/Common';

import SearchInput from '../../utils/utilities/SearchInput';


import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { searchTickets } from './apiService';

// useSearchDebounce
import useSearchDebounce from '../../hooks/useSearchDebounce';

import StationsComponent from './Components/Stations';


import InHouseDashboard from './Components/Dashboard/InHouseDash';
import VendorDashboard from './Components/Dashboard/VendorDash';

import ViewRepairDialog from './Components/ViewRepairDialog';


const Container = styled.div`
  overflow-y: hidden;
`

const TopBoard = styled(BasicFlex)`
  margin-bottom: 1rem;
  /* gap: 30rem; */

  @media ${props => props.theme.breaks.down('md')} {
    flex-direction: column;
    gap: .5rem;
    align-items: flex-start;
    margin-bottom: 2rem;
  }
`

const BoardTitle = styled.h2`
  margin: 0;
  margin-bottom: 1rem;
  font-size: 1.8rem;
  font-weight: 500;
  color: ${props => props.theme.colors.lightText};
  min-width: 20rem;
`

const Dashboard = () => {

  const [openDialog, setOpenDialog] = useState(false);

  const [selectedTicket, setSelectedTicket] = useState(null);

  const [serviceType, setServiceType] = useState("in_house");

  const { searchTerm, updateSearchTerm } = useSearchDebounce();

  const { data: tickets } = useQuery({
    queryKey: ['repair_tickets', searchTerm, serviceType],
    queryFn: () => searchTickets(searchTerm, serviceType),
    // enabled: !!searchTerm || searchTerm === "",
    keepPreviousData: true
  })

  return (
    <Container>
      <TopBoard>
        <BoardTitle>Repair Dashboard</BoardTitle>
        <BasicFlex gap="1rem">
          <SearchInput onChange={updateSearchTerm} fieldsToSearch={[ "Customer", "Wig ID", "Ticket ID"]} />
          <StationsComponent service_type={serviceType} />
        </BasicFlex>
      </TopBoard>

      <ToggleButtonGroup color="tertiary" value={serviceType} onChange={(e, value) => setServiceType(value)} size="small" sx={{mt: "1rem", mb: "2rem"}} fullWidth exclusive >
        {/* <ToggleButton value="all">All Repairs</ToggleButton> */}
        <ToggleButton value="in_house">In House</ToggleButton>
        <ToggleButton value="external">Vendor Repairs</ToggleButton>
      </ToggleButtonGroup>

      {serviceType === "in_house" ? <InHouseDashboard tickets={tickets} setTicket={setSelectedTicket} setOpen={setOpenDialog} /> : <VendorDashboard tickets={tickets} setTicket={setSelectedTicket} setOpen={setOpenDialog} />}

      <ViewRepairDialog ticket={selectedTicket} open={openDialog} setOpen={setOpenDialog} setSelectedTicket={setSelectedTicket} dash={true} />

    </Container>
  )
};

export default Dashboard;